export const AGENCY_FEE = [
  { title: "room.list.step3.agencyFee.yes", value: "yes" },
  { title: "room.list.step3.agencyFee.no", value: "no" },
];
